const css = `.exercise-progress-dialog {
  width: 100%;
  max-width: min(1300px, 95vw);
  height: 100%;
}
.exercise-progress-dialog.p-dialog.big-modal > .p-dialog-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 12px 0 0;
  overflow-y: visible;
}
.exercise-progress-dialog .exercise-progress-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.exercise-progress-dialog .exercise-progress-content .exercise-progress-filters {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-strong);
  row-gap: 8px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-progress-filters .date-range-selector {
  width: 100%;
  max-width: 250px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-progress-filters .exercise-search {
  width: 100%;
  max-width: 400px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-progress-filters .exercise-search .p-input-icon {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
}
.exercise-progress-dialog .exercise-progress-content .exercises-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 8px 12px 0;
  flex: 1;
  min-height: 0;
  border-bottom: 1px solid var(--border-strong);
}
.exercise-progress-dialog .exercise-progress-content .loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px;
  color: var(--text-color-secondary);
  flex: 1;
}
.exercise-progress-dialog .exercise-progress-content .loading-state p {
  margin: 0;
  font-size: var(--font-size-base);
}
.exercise-progress-dialog .exercise-progress-content .no-exercises {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px;
  color: var(--text-color-secondary);
  flex: 1;
}
.exercise-progress-dialog .exercise-progress-content .no-exercises i {
  font-size: var(--font-size-2xl);
}
.exercise-progress-dialog .exercise-progress-content .no-exercises p {
  margin: 0;
  font-size: var(--font-size-base);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  row-gap: 24px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-header .exercise-header-left {
  display: flex;
  gap: 12px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-header .exercise-name {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-color);
  line-height: var(--line-height-tight);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics {
  display: flex;
  align-items: center;
  gap: 24px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .metric-label {
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-bold);
  color: var(--text-color-secondary);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wide);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .progress-value {
  white-space: nowrap;
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-color);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .progress-value.big-diff {
  color: var(--success);
  align-items: center;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .progress-value.big-diff .progress-diff {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .progress-value.big-diff.negative-big-diff {
  color: var(--danger);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .progress-value .progress-diff-separator {
  font-weight: var(--font-weight-regular);
  color: var(--text-color-secondary);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .progress-value .progress-diff {
  color: var(--success);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-metrics .metric .progress-value .progress-diff.negative-diff {
  color: var(--danger);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details {
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details .exercise-metric-container {
  display: flex;
  align-items: end;
  gap: 12px;
  padding-bottom: 16px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details .exercise-metric-container h4 {
  min-width: 104px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--text-color);
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details .exercise-metric-container .exercise-metrics .metric {
  width: 80px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details .exercise-metric-container .exercise-metrics .metric.metric-big-diff {
  width: 130px;
}
.exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details .p-chart {
  width: 100%;
  height: 260px;
  position: relative;
}

@media (max-width: 768px) {
  .exercise-progress-dialog.p-dialog.big-modal {
    max-width: 98vw;
    padding-left: 8px;
    padding-right: 8px;
  }
  .exercise-progress-dialog.p-dialog.big-modal .p-dialog-header {
    padding-left: 8px;
    padding-right: 8px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercise-progress-filters {
    padding-left: 8px;
    padding-right: 8px;
    flex-direction: column-reverse;
  }
  .exercise-progress-dialog .exercise-progress-content .exercise-progress-filters .date-range-selector {
    max-width: 400px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-header {
    flex-direction: column;
    align-items: start;
  }
  .exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details {
    padding: 8px 0;
    gap: 24px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details .exercise-metric-container {
    flex-direction: column;
    align-items: start;
  }
  .exercise-progress-dialog .exercise-progress-content .exercise-accordion .exercise-details .exercise-metric-container h4 {
    margin-left: 24px;
  }
}
@media (max-width: 480px) {
  .exercise-progress-dialog {
    max-width: 100%;
    max-height: 100%;
  }
  .exercise-progress-dialog.p-dialog.big-modal {
    max-width: 100vw;
    padding-left: 0px;
    padding-right: 0px;
  }
  .exercise-progress-dialog.p-dialog.big-modal .p-dialog-header {
    padding-left: 12px;
    padding-right: 12px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercise-progress-filters {
    padding-left: 12px;
    padding-right: 12px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list {
    padding-right: 2px;
    padding-left: 4px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .p-accordion-header-link {
    padding-left: 4px;
    padding-right: 8px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .p-toggleable-content .p-accordion-content {
    padding: 0 !important;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-header .exercise-metrics .metric {
    width: 80px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-header .exercise-metrics .metric.metric-rir {
    width: 40px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-header .exercise-metrics .metric.metric-rpe {
    width: 40px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-details {
    padding: 8px 0 8px 4px;
    gap: 8px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-details .exercise-metric-container {
    padding: 12px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-details .exercise-metric-container h4 {
    margin-left: 12px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-details .exercise-metric-container .exercise-metrics {
    flex-wrap: wrap;
    justify-content: center;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-details .exercise-metric-container .exercise-metrics .metric {
    width: 60px;
  }
  .exercise-progress-dialog .exercise-progress-content .exercises-list .exercise-accordion .exercise-details .exercise-metric-container .exercise-metrics .metric.metric-big-diff {
    width: 130px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
